import styled from 'styled-components'
import { backgroundOrange, border1, orange, white } from '@/theme/colors'
import { flatButton } from '@/theme/recipes'
import { motion, radii } from '@/theme/tokens'

/**
 * A selectable row in a picker list — an avatar or a glyph, a name, a meta
 * line — that is one option among siblings: the user pickers, the pay-up
 * member list, the activity filter's category rows, the category sheet. A
 * real button on the flatButton recipe with a hairline card ground;
 * `$selected` marks the chosen one and hover previews it. A row that opens or
 * expands rather than selects is not this.
 */
export const OptionRow = styled.button<{ $selected?: boolean }>`
	${flatButton}
	display: flex;
	align-items: center;
	gap: 14px;
	width: 100%;
	padding: 16px 18px;
	text-align: left;
	border-radius: ${radii.small};
	background: ${({ $selected }) => ($selected ? backgroundOrange : white)};
	border: 1px solid ${({ $selected }) => ($selected ? orange : border1)};
	transition: all ${motion.fast};

	&:hover {
		border-color: ${orange};
		background: ${backgroundOrange};
	}
`
